import script from "./MoveTaskCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./MoveTaskCard.vue?vue&type=script&setup=true&lang=ts"

import "./MoveTaskCard.vue?vue&type=style&index=0&id=fd877f6c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src014250190/src/byggesoknaden-support-gui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd877f6c"]])

export default __exports__